import { Connection } from '@xyflow/react';

import { FlowEdge } from '../Models/GraphModel';
import { TransitionModel } from '../Models/FlowModel';

export function hasOtherFlowConnection(edges: FlowEdge[], connection: Pick<Connection, 'source' | 'target'>, excludedEdgeId?: string): boolean {
	return edges.some((edge) => edge.id !== excludedEdgeId && edge.source === connection.source && edge.target === connection.target);
}

/** Keep transition identity/configuration and persist the new ports for save/reload. */
export function reconnectFlowEdge(edge: FlowEdge, connection: Connection): FlowEdge {
	const transition = edge.data as TransitionModel | undefined;
	const data = transition && {
		...transition,
		To: connection.target,
		Metadata: {
			...transition.Metadata,
			sourceHandle: connection.sourceHandle ?? undefined,
			targetHandle: connection.targetHandle ?? undefined,
		},
	};
	return {
		...edge,
		...connection,
		data,
	};
}
